export default __webpack_public_path__ + "static/media/bannerbg-gradient-mask@3x.99b63f9c.png";